import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ViewPost from '../views/ViewPost.vue'
import ViewTag from '../views/ViewTag.vue'
import About from '../views/About.vue'
import ViewTags from '../views/ViewTags.vue'
import ViewProjects from '../views/ViewProjects.vue'
import ViewProject from '../views/ViewProject.vue'
import Links from '../views/Links.vue'
import LeaveMessage from '../views/LeaveMessage.vue'
import Service from '../views/Service.vue'
import ViewPosts from '../views/ViewPosts.vue'
import NotFound from '../views/errors/NotFound.vue'
import count from '../views/count'
import poetry from '../views/poetry.vue'
const children = []

let Posts = null
try {
  Posts = require('@/../posts/data/posts.json')
} catch (e) {
  Posts = require('@/defaults/posts.json')
}

Posts.posts.map(post => {
  children.push({
    path: post.id,
    component: async function () {
      let value
      await import(`@/../posts/${post.id}.md`).then((val) => {
        value = val
      })
      return value.vue.component
    }
  })
})
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/posts',
    name: 'ViewPosts',
    component: ViewPosts
  },
  {
    path: '/post/:index',
    name: 'ViewPost',
    component: ViewPost,
    children: children
  },
  {
    path: '/tags/:tag',
    name: 'ViewTag',
    component: ViewTag
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/leaveMessage',
    name: 'LeaveMessage',
    component: LeaveMessage
  },
  {
    path: '/tags',
    name: 'ViewTags',
    component: ViewTags
  },
  {
    path: '/projects',
    name: 'ViewProjects',
    component: ViewProjects
  },
  {
    path: '/project/:index',
    name: 'ViewProject',
    component: ViewProject
  },
  {
    path: '/links',
    name: 'Links',
    component: Links
  },
  {
    path: '/service',
    name: 'Service',
    component: Service
  },
  {
    path: '/poetry',
    name: 'poetry',
    component: poetry
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  },
  {
    path: '/count',
    name: 'Count',
    component: count
  }
]

// 防止连续点击多次路由报错
const routerPush = VueRouter.prototype.push
const routerReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push (location) {
  return routerReplace.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
